import fetch from "isomorphic-fetch";
import { z } from "zod";

import { isAccessRedirectError } from "@lib/access/access";
import { handleError } from "@lib/utils/error";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";
import { apiConf } from "./index";
export const CreateLocationSchema = z.object({
    id: z.string(),
    organisationId: z.string().optional(),
    postalCode: z.string(),
    city: z.string(),
    lat: z.number(),
    lng: z.number(),
    country: z.string(),
    confirmed: z.boolean().optional(),
    address: z.string(),
    description: z.string().optional(),
    online: z.boolean().optional(),
    favorite: z.boolean(),
});

export type CreateLocation = z.infer<typeof CreateLocationSchema>;

type CreateLocationParams = { organisationId: string; location: Omit<CreateLocation, "id"> };
export async function createLocation(params: CreateLocationParams) {
    try {
        const resp = await fetch(
            withAccountOrNetworkAuthHeaders(
                `${apiConf.BACK_URL}/organisations/${params.organisationId}/locations`,
                {
                    method: `POST`,
                    body: JSON.stringify(params.location),
                },
            ),
        );

        if (resp.status >= 400) {
            handleError(await resp.json(), resp.status);
            return null;
        }

        const json = await resp.json();

        return CreateLocationSchema.parse(json);
    } catch (e) {
        // The shared 401 handler already scheduled the redirect; preserve this API's null result.
        if (isAccessRedirectError(e)) return null;
        handleError(e, 500);
    }
}
